export default class LogList {
  constructor() {
    this.fns = [];
    this.index = 0;
    this.list = [];
    this.running = false;
  }

  addRecord(f) {
    this.fns.push(f);
    setTimeout(() => this.run(), 1000);
  }

  run() {
    this.running = true;
    if (this.index >= this.fns.length) {
      this.running = false;
      return;
    }
    const f = this.fns[this.index];
    this.fns[this.index] = null;
    ++this.index;
    const str = f();
    if (this.index % 100 === 0) {
      console.log(`${this.index} / ${this.fns.length}`);
    }
    this.list.push(str);
    setTimeout(() => this.run());
  }

  show() {
    const str = this.list.map((line, index) => `Item ${index}. L${"".padStart(Math.floor(Math.log10(line.length)), 'A')}\n${line}`).join('\n\n\n');
    this.list.length = 0;
    return str;
  }
}
